/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_PeriodsInputs */



/**
* | output |
* | --- |
* | "Billing periods" |
*
* @param {Partner_Detail_PeriodsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_periods = /** @type {((inputs?: Partner_Detail_PeriodsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_PeriodsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnungszeiträume")
	return /** @type {LocalizedString} */ ("Billing periods")
});